import { render } from "./AttestOverview.vue?vue&type=template&id=1597de6d&scoped=true"
import script from "./AttestOverview.vue?vue&type=script&lang=js"
export * from "./AttestOverview.vue?vue&type=script&lang=js"

import "./AttestOverview.vue?vue&type=style&index=0&id=1597de6d&lang=css"
import "./AttestOverview.vue?vue&type=style&index=1&id=1597de6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1597de6d"]])

export default __exports__